import { axiosApi } from 'app/api/api';
import { AdminRequestData } from 'entities/adminRequest/model/adminRequestModel';

export const adminRequestsApi = {
  fetch: async () => {
    const res = await axiosApi.get<AdminRequestData[]>(
      `/admin/get_all_requests`
    );

    return res.data;
  },
  accept: async (id: string, email: string, name: string) => {
    await axiosApi.get(`/admin/approve`, {
      params: { user_id: id, email, name },
    });

    return true;
    // return new Promise<boolean>((resolve) => {
    //   setTimeout(() => {
    //     resolve(true);
    //   }, 500);
    // });
  },
  decline: async (id: string, email: string, name: string) => {
    await axiosApi.get(`/admin/decline`, {
      params: { user_id: id, email, name },
    });

    return true;
    // return new Promise<boolean>((resolve) => {
    //   setTimeout(() => {
    //     resolve(true);
    //   }, 500);
    // });
  },
};
